/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/warranty_product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "CreateWarrantyProductRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "productKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "serialNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "sqUserAgent": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "serviceCloudCaseNumber": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "warrantyReasonId": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateWarrantyProductResponse": {
                    "fields": {
                      "product": {
                        "type": "squareup.solidshop.v2.resources.WarrantyProduct",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE CreateWarrantyProductRequest @ squareup/solidshop/v2/service/warranty_products/create_warranty_product.proto at 11:1
 */
export const CreateWarrantyProductRequest = $root.lookupType('squareup.solidshop.v2.service.CreateWarrantyProductRequest');
fixType(CreateWarrantyProductRequest);
Builder.createAndAttachToType(CreateWarrantyProductRequest);
/**
 * SOURCE CreateWarrantyProductResponse @ squareup/solidshop/v2/service/warranty_products/create_warranty_product.proto at 34:1
 */
export const CreateWarrantyProductResponse = $root.lookupType('squareup.solidshop.v2.service.CreateWarrantyProductResponse');
fixType(CreateWarrantyProductResponse);
Builder.createAndAttachToType(CreateWarrantyProductResponse);
